import { format } from 'date-fns';
import esLocale from "date-fns/locale/es";
import getYear from 'date-fns/getYear';

const removeNullValues = (object) => {
  const newObject = JSON.parse(JSON.stringify(object), (key, value) => {
    if (value == null) {
      if (typeof key === 'string') {
        return ''
      } else {
        return undefined;
      }
    }
    return value;
  });
  return newObject;
}

const validacionesYup = {
  phoneNumber: /^\+\d{10,13}$/,
  cuit: /\b(20|23|24|27|30|33|34)(\D)?[0-9]{8}(\D)?[0-9]/
}

export function getFechaMesAndFechaAno(fecha: Date) {
  let fechaMes = format(fecha, "MMMM", { locale: esLocale });
  fechaMes = fechaMes.replace(/^./, fechaMes[0].toUpperCase());
  const fechaAno = `${getYear(fecha)}`;
  return { fechaMes, fechaAno }
}

function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

export default {
  removeNullValues,
  validacionesYup,
  getFechaMesAndFechaAno,
  sleep
}
